<template>
  <div>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="80px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="单号">
            <el-input
              size="small"
              v-model="filter.number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="filter.status" multiple>
              <el-option
                v-for="(value, index) in PurchaseOrderStatusMap"
                :key="index"
                :label="value"
                :value="parseInt(index)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间" prop="date">
            <el-date-picker
              clearable
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结算日期" prop="settle_date">
            <el-date-picker
              clearable
              v-model="filter.settle_date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData(false)
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel">
      <file-button
        obj="purchase_order"
        :importButton="false"
        :filter="filter"
        style="float: right"
        v-code="61101"
      ></file-button>
      <mytable :list="list" :category="category"></mytable>
      <el-pagination
        background
        class="m-t-20 text-right"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import mytable from './table.vue'
import { purchaseOrderList } from '../../../service/getData'
import { PurchaseOrderStatusMap } from '../../../config/global'
export default {
  props: {
    category: {
      type: Number,
      default: 1,
    },
  },
  components: {
    mytable,
  },
  data() {
    return {
      PurchaseOrderStatusMap,
      filter: {
        // category: this.category,
        page: 1,
        size: 10,
        status: '',
        number: '',
        date: '',
        settle_date: '',
      },
      total: 0,
      list: [],
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.status = ''
        this.filter.number = ''
        this.filter.date = ''
        this.filter.settle_date = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1

      if (params.date && params.date.length == 2) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }

      if (params.settle_date && params.settle_date.length == 2) {
        params.settle_start_date = params.settle_date[0]
        params.settle_end_date = params.settle_date[1]
      }

      let res = await purchaseOrderList(params)
      if (res.code == 0) {
        this.list = res.data.list
        this.total = res.data.count
      }
    },
  },
}
</script>